import React from 'react';
import PropTypes from 'prop-types';

import Caret from 'components/Select/caret';
import Heading from 'components/Heading';

import {
  MobileNavViewport,
  ListWrapper,
  RowWrapper,
} from './mobileUserNav.styled';

export default function MobileUserNav(props) {
  const { list } = props;
  if (!Array.isArray(list)) return null;

  const { show, title } = props;

  return (
    <MobileNavViewport show={show}>
      <ListWrapper as='ul' show={show}>
        {title && (
          <RowWrapper parent onClick={props.onClickParent}>
            <Heading level='4'>{title}</Heading>
            <Caret />
          </RowWrapper>
        )}
        {list.map(
          (obj, index) =>
            obj?.node && (
              <RowWrapper key={index} onClick={obj?.onClick}>
                {obj?.node}
              </RowWrapper>
            ),
        )}
      </ListWrapper>
    </MobileNavViewport>
  );
}

MobileUserNav.defaultProps = {
  show: false,
};

MobileUserNav.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.object),
  onClickParent: PropTypes.func,
};
